import React from "react";

export function TooltipPeriodoTeste(props) {
    const periodoTeste = props.item.periodo_teste || [];
    if (!periodoTeste.length) return null;
    const mesInicio = "" + JSON.parse(periodoTeste[0]).mes;
    const anoInicio = "" + JSON.parse(periodoTeste[0]).ano;
    const mesFim = "" + JSON.parse(periodoTeste[periodoTeste.length - 1]).mes;
    const anoFim = "" + JSON.parse(periodoTeste[periodoTeste.length - 1]).ano;
    const inicioTeste = mesInicio + "/" + anoInicio;
    const fimTeste = mesFim + "/" + anoFim;
    const hoje = new Date();
    const periodoTesteVigente = new Date(hoje.getFullYear(), hoje.getMonth()) <= new Date(parseInt(anoFim), mesFim - 1);

    return (
        <div
            className={props.item.alerta_periodo_teste_visualizado || periodoTesteVigente ? "" : "aumentar-diminuir"}
            style={{
                color: "#FFF",
                backgroundColor: "#257bfb",
                padding: 3,
                borderRadius: "0.3rem",
                fontSize: "0.7rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minWidth: "fit-content",
                textWrap: "nowrap",
                flexGrow: 1,
                margin: 3,
            }}
            title={`Período de Testes ativo: Início ${inicioTeste} - Fim ${fimTeste}`}
            onClick={() => {
                if (props.item.alerta_periodo_teste_visualizado || periodoTesteVigente) return;
                props.setPeriodoTesteVisualizado({ id: props.item.id, callback: props.getMonitoramentoConsumo });
            }}
        >
            <b>PERÍODO TESTE</b>
        </div>
    );
}
